module.exports = __webpack_public_path__ + "static/media/instagram.fb2010be.webp";